// Статусы карт из GET /v1/cards по экранам вкладки «Карта» (как в ~/emcd/cards, useCardUtils.ts)

// Выпуск ждёт прохождения KYC → WaitingKyc
export const KYC_REQUESTED_STATUS = "kyc_requested";

// Выпуск отменён: CardIssueFailed, только если PendingCard ждал эту карту
export const CANCELED_CARD_STATUS = "canceled";

// Карта выпускается → PendingCard, в стопке — в виде «выпускаем»; audit_not_passed — тоже, как в вебе
export const PENDING_CARD_STATUSES = [
  "requested",
  "auditing",
  "need_topup",
  "audit_pass",
  "audit_not_passed",
  "active_processing",
];

// Карта выпущена → CardsIndex
export const ISSUED_CARD_STATUSES = [
  "active",
  "inactive",
  "freeze",
  "blocked",
  "withdraw_pending",
];

// Карты в общей истории операций: выпущенные и закрытые (как в ~/emcd/cards, AllCards.vue)
export const HISTORY_CARD_STATUSES = [...ISSUED_CARD_STATUSES, "closed"];

// Пока есть карта в одном из этих статусов, новую заказать нельзя (как ISSUE_BLOCKING_STATUSES в ~/emcd/cards)
export const ISSUE_BLOCKING_STATUSES = [
  "auditing",
  "kyc_requested",
  "need_topup",
  "requested",
];

// Вид карты (VirtualCard) по статусу, как в ~/emcd/cards: inactive — заморожена, freeze — закрывается;
// blocked — заблокирована, withdraw_pending — остаток выводится на кошелёк; выпускаемая — без баланса и номера
export const CARD_STATE = {
  ACTIVE: "active",
  FROZEN: "frozen",
  BLOCKED: "blocked",
  ISSUING: "issuing",
};
const FROZEN_CARD_STATUSES = ["inactive", "freeze"];
const BLOCKED_CARD_STATUSES = ["blocked", "withdraw_pending"];

export const getCardState = (status) => {
  if (FROZEN_CARD_STATUSES.includes(status)) return CARD_STATE.FROZEN;
  if (BLOCKED_CARD_STATUSES.includes(status)) return CARD_STATE.BLOCKED;
  if (PENDING_CARD_STATUSES.includes(status)) return CARD_STATE.ISSUING;
  return CARD_STATE.ACTIVE;
};

// Состояние экрана TopUpStatus по transaction_status ответа POST /v1/cards/{id}/topups
// (значения — из ~/emcd/cards: TopUpResponse, TransactionStatus; регистр у бэкенда разный)
export const TOPUP_STATE = {
  SUCCESS: "success",
  PENDING: "pending",
  ERROR: "error",
};
const PENDING_TOPUP_STATUSES = ["pending", "processing"];
const FAILED_TOPUP_STATUSES = ["declined", "failed"];

export const getTopupState = (transactionStatus) => {
  const status = String(transactionStatus ?? "").toLowerCase();
  if (PENDING_TOPUP_STATUSES.includes(status)) return TOPUP_STATE.PENDING;
  if (FAILED_TOPUP_STATUSES.includes(status)) return TOPUP_STATE.ERROR;
  return TOPUP_STATE.SUCCESS;
};
